<template>
  <div v-if="cart_items_count">
    <div class="media" v-if="payment_needed">
      <!-- <div class="icon-main">
        <div class="icon-round">
          <svg width="25" height="20" fill="none">
            <use xlink:href="#CreditCardW" />
          </svg>
        </div>
      </div> -->
      <div class="media-body">
        <div class="timeline-card">
          <h4>{{ _T('Payment Method') }}</h4>
          <div class="delivery-content saved-payment">
            <h4 class="mb-2">{{ _T('Saved credit card') }}</h4>

            <div class="radio-credit">
              <template v-if="customer_saved_credit_cards.length">
                <label
                  class="d-inline-block"
                  v-for="(card, key) in customer_saved_credit_cards"
                  :key="key"
                >
                  <input
                    class="radio_animated"
                    id="edo-ani"
                    type="radio"
                    v-model="selectedPaymentMethod"
                    :value="'savedcard.' + card.card_id"
                  />
                  <div class="saved-details">
                    <img
                      :src="'/images/checkout/' + card_image(card.card_type)"
                      alt
                      class="img-fluid"
                    />
                    <h6>
                      {{ _T(card.card_type) }}
                      <span class="d-block">XXXX-{{ card.card_last4 }}</span>
                    </h6>
                  </div>
                </label>
              </template>
              <p v-if="!customer_saved_credit_cards.length">
                {{ _T(`You don't have any card saved yet`) }}
              </p>
            </div>
            <div class="other-method radio-credit">
              <div class="d-flex">
                <h4 class="pl-2">{{ _T('Credit/Debit Card') }}</h4>
              </div>
              <label class="d-inline-block">
                <input
                  class="radio_animated"
                  id="edo-ani"
                  type="radio"
                  v-model="selectedPaymentMethod"
                  value="creditcard"
                />
                <div class="saved-details">
                  <svg width="40" height="40" class="creditCard">
                    <use xlink:href="#creditCard" />
                  </svg>
                </div>
              </label>
              <div
                class="credit-card-form"
                v-show="selectedPaymentMethod == 'creditcard'"
              >
                <credit-card-form></credit-card-form>
              </div>
            </div>
            <div class="other-method radio-credit">
              <h4>{{ _T('Other Method') }}</h4>
              <label class="d-block w-100">
                <input
                  class="radio_animated"
                  id="edo-ani2"
                  type="radio"
                  value="COD"
                  v-model="selectedPaymentMethod"
                />
                <div class="saved-details">
                  <img
                    src="/images/checkout/method.jpg"
                    alt
                    class="img-fluid"
                  />
                  <h6>
                    {{ _T('Cash On Delivery') }}
                    <span class="d-block">
                      {{ _T('Pay when your order arrives') }}
                    </span>
                  </h6>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="media loyalty">
      <div class="media-body details">
        <div class="timeline-card">
          <h6>
            {{
              _T('You have used cashback as a payment method. You are using')
            }}
            <span class="ml-1 mr-1">{{ currency }} {{ loyalty_spent }} </span>
            {{ _T('cashback points') }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreditCardForm from '@/components/Blocks/CreditCardForm.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'PaymentMethod',
  components: {
    CreditCardForm,
  },
  data() {
    return {
      isModalVisible: false,
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      'customer_saved_credit_cards',
      'cart_items_count',
      'payment_needed',
      'loyalty_spent',
    ]),

    selectedPaymentMethod: {
      get() {
        return this.$store.state.payment_store.selectedPaymentMethod
      },
      set(val) {
        this.$store.commit('SELECT_PAYMENT_METHOD', val)
      },
    },
  },
  watch: {},
  methods: {
    card_image(type) {
      let img = 'mastercard.png'

      switch (type) {
        case 'VISA':
          img = 'visa.png'
          break
      }
      return img
    },
    showModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .media {
    .media-body {
      .timeline-card {
        text-align: right;
      }
    }
  }
}
.creditCard {
  margin-top: -$px10 !important;
}
.loyalty {
  display: flex;
  align-items: center;
  max-width: 94%;
  margin-left: auto;
  &:hover {
    .timeline-card {
      background-color: rgba($color: #000000, $alpha: 0.05);
      transition: background-color 0.5 ease-in;
      cursor: pointer;
    }
  }

  .details {
    h6 {
      font-style: normal;
      font-weight: 600;
      font-size: $px14;
      line-height: $px22;
      letter-spacing: 0.005em;
      color: $font-color;
      margin-bottom: 0;
      span {
        font-weight: 600;
        font-size: $px14;
        line-height: $px22;
        letter-spacing: 0.005em;
        background: $warning-color;
        color: #fff;
        padding: $px8 $px12;
        border-radius: $px6;
      }
    }
  }
}
</style>
